const COLOR_TYPES = {
  HEX_TYPE: 'hex',
  HSL_TYPE: 'hsl',
  RGB_TYPE: 'RGB',
};

export default COLOR_TYPES;
